import { Banner, CardGrid } from '@if/mui'
import { Stack } from '@mui/material'
import {
  useImportAllIfxBankJob,
  useImportAllIfxLoans,
  useTerminateEtlBatchOrchestrator,
  useTerminateLoanValidationOrchestrator,
} from '@src/api/admin-commands-api'
import { DevToolsCommandType } from '@src/types/dev-tools'
import { useTranslation } from 'react-i18next'
import AdminCommandCard from './AdminCommandCard'
import CleanLoansByProgramCard from './CleanLoansByProgramCard'
import GenerateMockFtfFileCard from './GenerateMockFtfFileCard'
import LoadLoansCard from './LoadLoansCard'
import ImportLoansByIdsCard from './ImportLoansByIdsCard'
import SystemFlowModesCard from './SystemFlowModesCard'

const DevToolsMain = () => {
  const { t } = useTranslation()

  const terminateEtlBatch = useTerminateEtlBatchOrchestrator()
  const terminateLoanValidation = useTerminateLoanValidationOrchestrator()
  const importAllIfxLoans = useImportAllIfxLoans()
  const importAllIfxBankJob = useImportAllIfxBankJob()

  return (
    <Stack spacing={3}>
      <Banner severity="warning">{t('admin.devTools.accessWarning')}</Banner>

      <CardGrid columns={{ xs: 1, md: 2 }} gap={3}>
        <AdminCommandCard
          title={t('admin.devTools.commands.terminateEtlBatch.title')}
          description={t('admin.devTools.commands.terminateEtlBatch.description')}
          actionLabel={t('admin.devTools.commands.terminateEtlBatch.actionLabel')}
          confirmationMessage={t('admin.devTools.commands.terminateEtlBatch.confirmationMessage')}
          onExecute={() => terminateEtlBatch.mutateAsync()}
          isPending={terminateEtlBatch.isPending}
          commandType={DevToolsCommandType.TerminateEtlBatch}
          tone="destructive"
        />
        <AdminCommandCard
          title={t('admin.devTools.commands.terminateLoanValidation.title')}
          description={t('admin.devTools.commands.terminateLoanValidation.description')}
          actionLabel={t('admin.devTools.commands.terminateLoanValidation.actionLabel')}
          confirmationMessage={t('admin.devTools.commands.terminateLoanValidation.confirmationMessage')}
          onExecute={() => terminateLoanValidation.mutateAsync()}
          isPending={terminateLoanValidation.isPending}
          commandType={DevToolsCommandType.TerminateLoanValidation}
          tone="destructive"
        />
        <AdminCommandCard
          title={t('admin.devTools.commands.importAllIfxLoans.title')}
          description={t('admin.devTools.commands.importAllIfxLoans.description')}
          actionLabel={t('admin.devTools.commands.importAllIfxLoans.actionLabel')}
          confirmationMessage={t('admin.devTools.commands.importAllIfxLoans.confirmationMessage')}
          onExecute={() => importAllIfxLoans.mutateAsync()}
          isPending={importAllIfxLoans.isPending}
          commandType={DevToolsCommandType.ImportAllIfxLoans}
        />
        <AdminCommandCard
          title={t('admin.devTools.commands.importAllIfxBankJob.title')}
          description={t('admin.devTools.commands.importAllIfxBankJob.description')}
          actionLabel={t('admin.devTools.commands.importAllIfxBankJob.actionLabel')}
          confirmationMessage={t('admin.devTools.commands.importAllIfxBankJob.confirmationMessage')}
          onExecute={() => importAllIfxBankJob.mutateAsync()}
          isPending={importAllIfxBankJob.isPending}
          commandType={DevToolsCommandType.ImportAllIfxBankJob}
        />
        <ImportLoansByIdsCard />
        <CleanLoansByProgramCard />
        <LoadLoansCard />
        <SystemFlowModesCard />
        <GenerateMockFtfFileCard />
      </CardGrid>
    </Stack>
  )
}

export default DevToolsMain
